const Marionette = require('backbone.marionette');
const templates = require('../templates');
const PopupFooterActuallyView = require('./popup_footer_actually.js');
const PopupFooterNextView = require('./popup_footer_next.js');
const app = require('../app.js');

module.exports = Marionette.LayoutView.extend({
  template: templates.popup_footer,
  initialize() {
    this.listenTo(app.vent, 'returnToDefault', this.returnToDefault);
  },
  returnToDefault() {
    this.closeFooterPopup();
  },
  regions: {
    popup_footer_actually: '.actually',
    popup_footer_next: '.next'
  },
  onBeforeShow() {
    const self = this;
    const actuallyCollection = this.model.get('actually');
    const nextCollection = this.model.get('next');

    this.listenTo(actuallyCollection, 'update', collection => {
      if (collection.isEmpty()) {
        self.getRegion('popup_footer_actually').empty();

        if (nextCollection.isEmpty()) {
          self.showChildView(
            'popup_footer_actually',
            new PopupFooterActuallyView({
              collection: actuallyCollection
            })
          );
        }
      } else {
        self.showChildView(
          'popup_footer_actually',
          new PopupFooterActuallyView({
            collection: actuallyCollection
          })
        );
      }
    });

    this.listenTo(nextCollection, 'update', collection => {
      if (collection.isEmpty()) {
        self.getRegion('popup_footer_next').empty();
      } else {
        self.showChildView(
          'popup_footer_next',
          new PopupFooterNextView({
            collection: nextCollection
          })
        );

        if (actuallyCollection.isEmpty()) {
          self.getRegion('popup_footer_actually').empty();
        }
      }
    });

    if (!actuallyCollection.isEmpty()) {
      this.showChildView(
        'popup_footer_actually',
        new PopupFooterActuallyView({
          collection: actuallyCollection
        })
      );
    }

    if (!nextCollection.isEmpty()) {
      this.showChildView(
        'popup_footer_next',
        new PopupFooterNextView({
          collection: nextCollection
        })
      );
    }

    if (actuallyCollection.isEmpty() && nextCollection.isEmpty()) {
      self.showChildView(
        'popup_footer_actually',
        new PopupFooterActuallyView({
          collection: actuallyCollection
        })
      );
    }
  },
  events: {
    click: 'closeFooterPopup'
  },
  closeFooterPopup() {
    app.vent.trigger('closeFooterPopup');
  },
  onRender() {
    const self = this;
    this.$el.swipe({
      swipe(event, direction) {
        if (direction === 'down') {
          self.closeFooterPopup();
        }
      }
    });
  }
});



// WEBPACK FOOTER //
// ./src/views/popup_footer.js